<div>
  <h2>{{'mantenimientoEtiquetadores.titulo' | translate}}</h2>
  <section class="filters-framed" *ngIf="filtersVisible">
    <form [formGroup]="filtersForm" [ngClass]="{'show-error': showError}">
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.pais' | translate}}</label>
        <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'mantenimientoEtiquetadores.filters.denominacion' | translate}}</label>
        <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
          [disabled]="disabledDenominaciones" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'mantenimientoEtiquetadores.filters.etiquetador' | translate}}</label>
        <input type="text" formControlName="des">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.inicio' | translate}}</label>
        <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
          (click)="fechaInicio.open()">
        <mat-datepicker #fechaInicio></mat-datepicker>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.fin' | translate}}</label>
        <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
        <mat-datepicker #fechaFin></mat-datepicker>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left-small move-left-next">
        <input type="radio" id="insercion" value="false" formControlName="dateType">
        <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
        <input type="radio" id="actualizacion" value="true" formControlName="dateType">
        <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
      </div>
      <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <checkbox [id]="'impAutorizada'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_impAutorizada" [label]="'mantenimientoEtiquetadores.filters.etqAutorizado'" (refresh)="this.refreshCheckbox_impAutorizada = false" (formValue)="this.filtersForm.get('impAutorizada').patchValue($event)" (pristine)="pristineCheckbox('impAutorizada', $event)"></checkbox>
      </div>
      <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <checkbox [id]="'reimpAutorizada'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_reimpAutorizada" [label]="'mantenimientoEtiquetadores.filters.reetqAutorizado'" (refresh)="this.refreshCheckbox_reimpAutorizada = false" (formValue)="this.filtersForm.get('reimpAutorizada').patchValue($event)" (pristine)="pristineCheckbox('reimpAutorizada', $event)"></checkbox>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
      <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
    </form>
  </section>
  <section class="filters-buttons">
    <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
      title="{{'global.filtros.abrir' | translate}}">
      <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
      (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
      <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary"
      [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
      title="{{'global.filtros.limpiar' | translate}}">
      <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
    </button>
    <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
      title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
      <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
    </button>
  </section>
  <section class="export-buttons">
    <i class="fas fa-file-pdf" [ngClass]="{'disabled': !etiquetadores}" (click)="exportModal = 1"
            title="{{'titles.exportarPDF' | translate}}"></i>
        <i class="fas fa-file-csv" [ngClass]="{'disabled': !etiquetadores}"
            (click)="exportModal = 2" title="{{'titles.exportarCSV' | translate}}"></i>
    <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
  </section>
  <div class="table-wrapper">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="icon" *ngIf="this.role !== 'Supervisor'"></th>
            <th class="id sortable" (click)="toOrderBy(2, 'x=> x.id')">{{'mantenimientoEtiquetadores.table.id' | translate}}
              <div class="sortable-icons sort-icons-padding">
                <i [ngClass]="getIcon(2)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy(3, 'x=> x.des')">{{'mantenimientoEtiquetadores.table.etiquetador' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon(3)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy(4, 'x=> x.alias')">{{'mantenimientoEtiquetadores.table.alias' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon(4)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy(5, 'x=> x.nifcif')">{{'mantenimientoEtiquetadores.table.nifcif' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon(5)"></i>
              </div>
            </th>
            <th class="string">{{'mantenimientoEtiquetadores.table.etqAutorizado' | translate}}</th>
            <th class="string">{{'mantenimientoEtiquetadores.table.reetqAutorizado' | translate}}</th>
            <th class="date sortable" (click)="toOrderBy(6, 'x=> x.fechaIns')">{{'global.fecha.insercionShort' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon(6)"></i>
              </div>
            </th>
            <th class="date sortable" (click)="toOrderBy(7, 'x=> x.fechaUpd')">{{'global.fecha.actualizacionShort' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon(7)"></i>
              </div>
            </th>
            <th class="action">
              <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" (click)="create()"
              title="{{'mantenimientoEtiquetadores.tituloNew' | translate}}"></i>
            </th>
          </tr>
        </thead>
        <tbody class="clickable" *ngFor="let etiquetador of etiquetadores; let i=index; trackBy: trackByEtiquetadorId">
          <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
            <td class="icon" *ngIf="this.role !== 'Supervisor'">
              <i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}">
              </i>
            </td>
            <td class="id td-padding">{{etiquetador.id}}</td>
            <td class="string">{{etiquetador.des}}</td>
            <td class="string">{{etiquetador.alias}}</td>
            <td class="string">{{etiquetador.nifcif}}</td>
            <td class="icon">
              <i *ngIf="etiquetador.impresionAutorizada" class="fa-regular fa-circle-check"
                  title="{{'titles.impresionAutorizada' | translate}}"></i>
              <i *ngIf="!etiquetador.impresionAutorizada" style="color:red" class="fa-regular fa-circle-xmark"
                  title="{{'titles.impresionDeshabilitada' | translate}}"></i>
            </td>
            <td class="icon">
              <i *ngIf="etiquetador.reimpresionAutorizada" class="fa-regular fa-circle-check"
                  title="{{'titles.reimpresionAutorizada' | translate}}"></i>
              <i *ngIf="!etiquetador.reimpresionAutorizada" style="color:red" class="fa-regular fa-circle-xmark"
                  title="{{'titles.reimpresionDeshabilitada' | translate}}"></i>
            </td>
            <td class="date-long">{{etiquetador.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
            <td class="date-long">{{etiquetador.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
            <td class="multi-actions">
              <i class="fas fa-stream" app-click-stop-propagation (click)="showSection(i)"
                 title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
              <i class="fas fa-pencil-alt" app-click-stop-propagation *ngIf="this.role === 'Administrador'"
                  (click)="update(etiquetador)" title="{{'titles.editar' | translate}}"></i>
              <i class="far fa-trash-alt" title="{{'titles.eliminarEtiquetador' | translate}}" *ngIf="this.role === 'Administrador'" [ngClass]="{'disabled': etiquetador.registroEnUso}"
                app-click-stop-propagation (click)="askDelete(etiquetador)"></i>
            </td>
          </tr>
          <tr *ngIf="dropdownInfo === i">
            <td colspan="10">
              <div class="detail">
                <div class="title">{{'global.masInformacion' | translate}}</div>
                <div class="block-inline">
                  <label>{{'mantenimientoEtiquetadores.table.ultimaConexion' | translate}}</label>
                </div>
                <div class="block-inline">
                  <label>{{'mantenimientoEtiquetadores.table.marcas' | translate}}</label>
                  <p>{{etiquetador.strMarcasAsociadas}}</p>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="dropdownSection === i">
            <td colspan="10">
              <section class="tabs">
                <ul>
                  <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showDenominaciones(i)">
                    {{'mantenimientoEtiquetadores.table.denominaciones' | translate}}
                  </li>
                  <li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showAlmacenes(i)">
                    {{'mantenimientoEtiquetadores.table.almacenes' | translate}}
                  </li>
                  <li *ngIf="this.role === 'Administrador'" [ngClass]="{'active': pestanaActiva[i] === 3}" (click)="showReetiquetadores(i)">
                    {{'mantenimientoEtiquetadores.table.reetiquetadores' | translate}}
                  </li>
                </ul>
                <content>
                  <app-etq-denominaciones *ngIf="pestanaActiva[i] === 1" [etiquetadorId]="etiquetador.id"
                    (pushMessage)="pushMessage($event)" (refresh)="refresh($event)"></app-etq-denominaciones>
                  <app-etq-almacenes *ngIf="pestanaActiva[i] === 2" [etiquetadorId]="etiquetador.id"
                    (pushMessage)="pushMessage($event)" (refresh)="refresh($event)"></app-etq-almacenes>
                  <app-etq-rtq *ngIf="pestanaActiva[i] === 3 && this.role !== 'Auditor'" [etiquetadorId]="etiquetador.id"
                    (pushMessage)="pushMessage($event)" (refresh)="refresh($event)"></app-etq-rtq>
                </content>
              </section>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="!etiquetadores || (etiquetadores && etiquetadores.length < 1)">
          <tr>
            <td colspan="10">
              {{'global.noContent' | translate}}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <app-paginator *ngIf="etiquetadores && etiquetadores.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
  <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
  <div class="modal-content">
    <header>
      <h4>{{'global.eliminar.descripcion' | translate}}</h4>
    </header>
    <content>
      <p>{{'global.eliminar.confirmacion' | translate}}</p>
    </content>
    <footer>
      <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
      <button (click)="delete()">{{'global.confirmar' | translate}}</button>
    </footer>
  </div>
</div>
<div class="modal" *ngIf="newEditModal">
  <div class="modal-content">
    <header>
      <h4>{{etiquetadorId ? ('mantenimientoEtiquetadores.tituloEdit' | translate) :
        ('mantenimientoEtiquetadores.tituloNew' | translate)}}</h4>
    </header>
    <app-mantenimientoEtiquetadores-new-edit [etiquetadorId]="etiquetadorId" (refresh)="refresh($event)"
      (mensaje)="pushMessage($event)">
    </app-mantenimientoEtiquetadores-new-edit>
  </div>
</div>
<div class="modal" *ngIf="exportModal > 0">
  <div class="modal-content">
      <header>
          <h4>{{'mantenimientoEtiquetadores.modalInformes.titulo' | translate}} {{exportModal === 1 ? 'PDF' : 'CSV'}}
          </h4>
          <i class="fas fa-times" (click)="exportModal = 0"></i>
      </header>
      <content>
          <button (click)="export(1)">{{'mantenimientoEtiquetadores.modalInformes.general' | translate}}</button>
          <button (click)="export(2)">{{'mantenimientoEtiquetadores.modalInformes.detallado' | translate}}</button>
      </content>
  </div>
</div>
